export enum Routes {
  Home = '/',
  Cleaner = '/cleaner',
}

export enum RouteIds {
  Home = 'home',
  Cleaner = 'cleaner',
}
